<template>
  <div>
    <v-card-text v-if="clientCargo && trip" style="padding:0">
      <div class="py-0">
        <v-row>
          <v-col cols="12" lg="3" md="3" sm="6">
            <z-client-select v-model="clientCargo.client_id" :owner_id="trip.vendor_id" withSelf
              @resetVendorEntity="resetVendorEntity" :disabled="trip.disableFareEdit" />
          </v-col>

          <v-col cols="12" lg="3" md="3" sm="6" v-if="clientCargo.client_id">
            <z-entity-select :corp="clientCargo.client_id" v-model="clientCargo.clientEntity_id"
              :label="$i18n.t('Client Entity')" :disabled="trip.disableFareEdit" autoSelect />
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="6" v-if="clientCargo.client_id">
            <TariffManager :client_id="clientCargo.client_id" v-model="tariff" />
          </v-col>
        </v-row>
      </div>

      <v-card class="my-0" v-if="trip">
        <v-card-title class="title card-title-head">
          {{ $i18n.t("Cargos") }}
          <v-spacer />
          <v-btn x-small fab text color="light-blue" class="float-right" @click="addNewEmptyCargo">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-0" style="padding:0" v-if="trip && clientCargo.cargos && clientCargo.cargos.length > 0">
          <v-simple-table v-if="trip">
            <v-card class="my-3" v-for="(c, i) in clientCargo.cargos" :key="i">
              <cargo :cargoItem="c" :cargos="clientCargo.cargos" :client_id="clientCargo.client_id" :indexItem="i"
                :trip="trip" :errors="errors" @reloadError="reloadError" />
            </v-card>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <billing-fare v-model="clientCargo.billing" v-if="clientCargo.client_id && trip.vendor_id && $ha('750&107')"
        :vehicleType="trip.truckType" :trip="trip" :myCorp_id="trip.myCorp_id" :forSupplier="false"
        :recalculateFare="true" />

      <fare-collection v-if="clientCargo.client_id && trip.vendor_id && trip._id && $ha('750&107')"
        :client_id="clientCargo.client_id" :clientEntity_id="clientCargo.clientEntity_id" :billing="clientCargo.billing"
        :trip="trip" :hideInvoices="true" @reload="closeDialog" />

      <v-row class="py-2">
        <v-col>
          <v-btn class="float-right" small color="blue" :title="$i18n.t('Create Invoice')" @click="createInvoiceDialog()"
            v-if="clientCargo.billing && !clientCargo.billing.invoice_id && trip.status > 4">
            <!-- <v-icon>mdi-receipt</v-icon> -->
            Make Invoice
          </v-btn>

          <v-menu v-if="($ha(740) && clientCargo.showPrintInvoice) ||
            ($ha(740) && clientCargo.showInvoice) ||
            ($ha(745) && clientCargo.showInvCreate) ||
            ($ha(745) && clientCargo.showInvVerify) ||
            ($ha(743) && clientCargo.showInvDelete)
            ">
            <template v-slot:activator="{ on }">
              <v-btn class="float-right" v-on="on" color="green" small>
                <!-- <v-icon>mdi-receipt</v-icon> -->
                Invoiced Options
              </v-btn>
            </template>
            <v-list v-if="$ha(740) && clientCargo.showInvoice && clientCargo.billing && clientCargo.billing.invoice_id">
              <!-- <v-btn
                    text
                    target="_blank"
                    :to="'/sales/invoice/' + clientCargo.billing.invoice_id"
                    ><v-icon>mdi-eye</v-icon> {{ $i18n.t("Show Invoice") }}</v-btn
              >-->
              <router-link v-if="$ha(340)" :to="'/sales/invoice/' + clientCargo.billing.invoice_id">
                <h4 class="my-2">
                  <v-icon>mdi-eye</v-icon>
                  {{ $i18n.t("Show Invoice") }}
                </h4>
              </router-link>
            </v-list>
            <v-list v-if="$ha(740) && clientCargo.showInvoice">
              <v-btn text @click="recreateInvoice()">
                <v-icon>mdi-refresh</v-icon>
                {{ $i18n.t("Recreate") }}
              </v-btn>
            </v-list>
            <v-list v-if="$ha(740) && clientCargo.showInvoice">
              <v-btn text @click="invEmail()">
                <v-icon>mdi-email</v-icon>
                {{ $i18n.t("Email Invoice") }}
              </v-btn>
            </v-list>
            <v-list v-if="$ha(745) && clientCargo.showInvCreate">
              <v-btn text @click="changeInvoiceStatus(0)">
                <v-icon>mdi-exclamation-thick</v-icon>
                {{ $i18n.t("Mark Unverified") }}
              </v-btn>
            </v-list>
            <v-list v-if="$ha(745) && clientCargo.showInvVerify">
              <v-btn text @click="changeInvoiceStatus(1)">
                <v-icon>mdi-check</v-icon>
                {{ $i18n.t("Mark Verified") }}
              </v-btn>
            </v-list>
            <v-list v-if="$ha(740) && clientCargo.showPrintInvoice">
              <v-btn text @click="invDownload()">
                <v-icon>mdi-printer</v-icon>
                {{ $i18n.t("Print Invoice") }}
              </v-btn>
            </v-list>
            <v-list v-if="$ha(743) && clientCargo.showInvDelete">
              <z-confirm-button text :title="$i18n.t('Delete Trip')" @click="deleteInvoice()"
                :message="$i18n.t('Do you want to cancel this trip ?')">
                <v-icon>mdi-trash-can-outline</v-icon>
                {{ $i18n.t("Delete Invoice") }}
              </z-confirm-button>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>

    <z-invoice-create :filters="finalFilters" :showDialog="showCreateInvoice" :selctedTrips="selctedTrips"
      @closeDialog="closeDialog" />
    <z-invoice-download :payload="payload" :showDialog="showInvoiceDownload" @closeDialog="closeOnlyDialog"
      :isMail="isMail" :invoice="invForMail"></z-invoice-download>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doGetWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Cargo from "@/views/trip/Cargo.vue";
import BillingFare from "@/views/trip/BillingFare.vue";
import FareCollection from "@/views/trip/FareCollection.vue";
import TariffManager from "@/views/tariff_new/TariffManager.vue";

@Component({
  name: "ClientCargo",
  props: {
    value: {
      default: null
    },
    clientCargoItem: {
      default: null
    },
    indexItem: {
      default: null
    },
    trip: {
      default: null
    },
    errors: {
      default: {}
    }
  },
  components: {
    Cargo,
    BillingFare,
    FareCollection,
    TariffManager
  }
})
export default class ClientCargo extends Vue {
  tariff = null;
  clientCargo = null;
  selctedTrips = [];
  finalFilters = {};
  showCreateInvoice = false;
  showInvoiceDownload = null;
  isMail = null;
  invForMail = null;
  payload = {};

  @Watch("tariff", { immediate: true })
  onTariffIdChanged(newValue, oldValue) {
    if (
      this.clientCargo
      && this.clientCargo.client_id
      && newValue
      && newValue.client_id
      && newValue.client_id == this.clientCargo.client_id
      && newValue.baseFare
    ) {
      const freightItem = this.ensureFreightItem(this.clientCargo);
      freightItem['unitCost'] =   newValue.baseFare;
      freightItem['amount'] = freightItem['unitCost'] * freightItem['units']
    }
  }

  ensureFreightItem(clientCargo) {

    if (!clientCargo) {
      clientCargo = {};
    }
    if (!clientCargo.billing) {
      clientCargo.billing = {};
    }

    if (!clientCargo.billing.fare) {
      clientCargo.billing.fare = {};
    }

    if (!clientCargo.billing.fare.charges) {
      clientCargo.billing.fare.charges = [];
    }

    const charges = clientCargo.billing.fare.charges;
    let freightItem = null;

    if (charges.length === 0) {
      freightItem = {
        name: 'Freight Charge',
        desc: null,
        units: 1,
        unitCost: null,
        amount: null,
      };

      const charge = {
        name: null,
        taxItem: {},
        discounts: [],
        items: [freightItem],
      };
      charges.push(charge);
    } else {
      for (let i = 0; i < charges.length; i++) {
        const charge = charges[i];
        if (charge && charge.items) {
          for (let j = 0; j < charge.items.length; j++) {
            if (charge.items[j]['name'] === 'Freight Charge') {
              freightItem = charge.items[j];
            }
          }
        }
      }
    }

    if (!freightItem) {

      freightItem = {
        name: 'Freight Charge',
        desc: null,
        units: 1,
        unitCost: null,
        amount: null,
      };
      const charge = {
        name: null,
        taxItem: {},
        discounts: [],
        items: [freightItem],
      };
      charges.push(charge);
    }
    return freightItem;
  }



  @Watch("clientCargo.client_id")
  updateClientInBilling() {
    if (this.clientCargo && this.clientCargo["client_id"]) {
      if (this.clientCargo["billing"]) {
        this.clientCargo["billing"]["client_id"] = this.clientCargo[
          "client_id"
        ];
      }
    }
  }

  goReload(r) {
    this.$emit("reload", r);
  }
  closeDialog(r) {
    this.closeOnlyDialog();
    this.goReload(r);
  }
  closeOnlyDialog() {
    this.showCreateInvoice = false;
    this.showInvoiceDownload = false;
    this.isMail = false;
    this.invForMail = null;
  }

  resetVendorEntity(entity_id) {
    if (this.trip) {
      this.trip.vendorEntity_id = entity_id;
    }
  }

  async getClientInvoiceStatus(billing) {
    let s = -1;
    if (billing && billing.clientInvStatus && billing.client_id) {
      s = parseInt(
        billing.clientInvStatus.replace(billing.client_id, "").replace("_", "")
      );
    }
    return s;
  }

  async getStatusList(status) {
    const statusList = [];
    if (status != null && status != undefined) {
      if (status == 0) {
        statusList.push(1);
      }
      if (status == 1) {
        statusList.push(0);
        statusList.push(3);
        statusList.push(5);
      }
      if (status == 3) {
        statusList.push(1);
        statusList.push(5);
      }
      if (status == 5) {
        statusList.push(3);
        statusList.push(1);
      }
    }
    return statusList;
  }

  async updateClientCargoAdditonalFields(clientCargo) {
    const invoiceStatus = await this.getClientInvoiceStatus(
      clientCargo.billing
    );
    const statusList = await this.getStatusList(invoiceStatus);
    if (clientCargo.billing && clientCargo.billing.invoice_id) {
      clientCargo.showPrintInvoice = true;
    }
    clientCargo.showInvoice = clientCargo.showPrintInvoice;
    if (statusList.indexOf(0) != -1) {
      clientCargo.showInvCreate = true;
    }
    if (statusList.indexOf(1) != -1) {
      clientCargo.showInvVerify = true;
    }
    if (clientCargo.billing && invoiceStatus == 0) {
      clientCargo.showInvDelete = true;
    }
    return clientCargo;
  }



  async mounted() {
    const temp = this.clientCargoItem;
    this.clientCargo = await this.updateClientCargoAdditonalFields(temp);
    this.index = this.indexItem;
  }

  @Watch("clientCargoItem")
  async onCargoChange(val) {
    const temp = val;
    this.clientCargo = await this.updateClientCargoAdditonalFields(temp);
  }

  @Watch("indexItem")
  onIndexChange(val) {
    this.index = val;
  }

  addNewEmptyCargo() {
    const cargo = {
      material: null,
      src: { country: "India", state: null, city: null, addressLine: null },
      dst: { country: "India", state: null, city: null, addressLine: null },
      invBranch: { address: {} },
      loadAsst: [],
      unloadAsst: [],
      lr: { insurance: { currency: "INR" } }
    };
    if (!this.clientCargo.cargos) this.clientCargo.cargos = [];
    this.clientCargo.cargos.push(cargo);
  }

  async downloadLR(_for, index) {
    try {
      common.setLoading(true);
      await doGetWithDownload(
        "/api/trip/" +
        this.trip._id +
        "/receipt/print?_for=" +
        _for +
        "&cargoIndex=" +
        index
      );
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  createInvoiceDialog() {
    const _payload = {};
    _payload.vendor_id = this.trip.vendor_id;
    _payload.client_id = this.clientCargo.client_id;
    _payload.clientEntity_id = this.clientCargo.clientEntity_id;
    _payload.vendorEntity_id = this.trip.vendorEntity_id;
    _payload.invoiceType = 2;
    _payload.trips = [];
    this.trip.fare = this.clientCargo.billing.fare;
    _payload.trips.push(this.trip);

    if (!_payload) {
      common.setError("Please select parameters");
      return;
    }
    if (!_payload.client_id) {
      common.setError("Client not provided");
      return;
    }
    if (!_payload.vendor_id) {
      common.setError("Vendor not provided");
      return;
    }
    if (!_payload.invoiceType) {
      common.setError("Type not provided");
      return;
    }
    if (!_payload.trips) {
      common.setError("Select trips");
      return;
    }
    const finalFilters = {};
    finalFilters.client_id = _payload.client_id;
    finalFilters.vendor_id = _payload.vendor_id;
    finalFilters.invoiceType = _payload.invoiceType;
    finalFilters.clientEntity_id = _payload.clientEntity_id;
    finalFilters.vendorEntity_id = _payload.vendorEntity_id;
    this.selctedTrips = _payload.trips;
    this.finalFilters = finalFilters;
    this.showCreateInvoice = true;
  }

  async recreateInvoice() {
    if (this.clientCargo.billing && this.clientCargo.billing.invoice_id) {
      try {
        common.setLoading(true);
        await doGet(
          "/api/invoice/" + this.clientCargo.billing.invoice_id + "/recreate"
        );
        this.$emit("reload", true);
        common.showMessage("Updated");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  invEmail() {
    if (this.clientCargo.billing && this.clientCargo.billing.invoice_id) {
      this.invForMail = {
        //TODO change if supplier invoiced
        _id: this.clientCargo.billing.invoice_id,
        client_id: this.clientCargo.client_id,
        clientEntity_id: this.clientCargo.clientEntity_id,
        vendor_id: this.trip.vendor_id,
        vendorEntity_id: this.trip.vendorEntity_id
      };
      this.isMail = true;
      this.showInvoiceDownload = true;
    }
  }

  invDownload() {
    if (this.clientCargo.billing && this.clientCargo.billing.invoice_id) {
      const _invoice = {
        //TODO change if supplier invoiced
        _id: this.clientCargo.billing.invoice_id,
        client_id: this.clientCargo.client_id,

        clientEntity_id: this.clientCargo.clientEntity_id,
        vendor_id: this.trip.vendor_id,
        vendorEntity_id: this.trip.vendorEntity_id
      };
      let ids = "";
      const clients = [];
      let vendor_id, client_id, vendorEntity_id, clientEntity_id;
      const v_consider = true;
      const c_consider = true;
      const vEntity_consider = true;
      const cEntity_consider = true;
      if (_invoice) {
        ids += _invoice._id;
        clients.push(_invoice.client_id);
        vendor_id = _invoice.vendor_id;
        client_id = _invoice.client_id;
        vendorEntity_id = _invoice.vendorEntity_id;
        clientEntity_id = _invoice.clientEntity_id;
      }
      // else {
      //     this.grid.rows.forEach(function (t) {
      //     if (t.selected) {
      //     ids += t._id + ",";
      //     clients.push(t.client_id);
      //     if (v_consider) {
      //         if (vendor_id == null) {
      //         vendor_id = t.vendor_id;
      //         } else if (vendor_id != t.vendor_id) {
      //         v_consider = false;
      //         }
      //     }
      //     if (c_consider) {
      //         if (client_id == null) {
      //         client_id = t.client_id;
      //         } else if (client_id != t.client_id) {
      //         c_consider = false;
      //         }
      //     }
      //     if (vEntity_consider) {
      //         if (vendorEntity_id == null) {
      //         vendorEntity_id = t.vendorEntity._id;
      //         } else if (vendorEntity_id != t.vendorEntity._id) {
      //         vEntity_consider = false;
      //         }
      //     }
      //     if (cEntity_consider) {
      //         if (clientEntity_id == null) {
      //         clientEntity_id = t.clientEntity._id;
      //         } else if (clientEntity_id != t.clientEntity._id) {
      //         cEntity_consider = false;
      //         }
      //     }
      //     }
      // });
      // }

      if (!ids) {
        common.setError("Please select invoice(s) to download PDF/Excel");
        return false;
      }

      const payload = { invoice_ids: ids, client_ids: clients };
      if (v_consider) {
        payload.vendor_id = vendor_id;
      }
      if (c_consider) {
        payload.client_id = client_id;
      }
      if (vEntity_consider) {
        payload.vendorEntity_id = vendorEntity_id;
      }
      if (cEntity_consider) {
        payload.clientEntity_id = clientEntity_id;
      }
      this.payload = payload;
      this.showInvoiceDownload = true;
    }
  }

  async changeInvoiceStatus(status) {
    if (
      status != null &&
      status != undefined &&
      this.clientCargo.billing &&
      this.clientCargo.billing.invoice_id
    ) {
      try {
        common.setLoading(true);
        await doGet(
          "/api/invoice/" +
          this.clientCargo.billing.invoice_id +
          "/status/" +
          status +
          "/update"
        );
        this.closeDialog(true);
        common.showMessage("Updated");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async deleteInvoice() {
    if (
      this.clientCargo &&
      this.clientCargo.billing &&
      this.clientCargo.billing.invoice_id
    ) {
      try {
        common.setLoading(true);
        await doGet(
          "/api/invoice/" + this.clientCargo.billing.invoice_id + "/delete"
        );
        this.closeDialog(true);
        common.showMessage("Updated");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  reloadError(reload, val) {
    this.$emit("reloadError", reload, val);
  }
}
</script>

<style scoped>
.v-text-field__details {
  display: none;
}

.v-input input[type="number"] {
  text-align: right !important;
}

.dense tr td {
  padding: 0 3px !important;
}

.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>